import { keepCodeDigits } from './frontend/registration/core/codeField';

keepCodeDigits();

$(document).on('click','.copy-info',function(){
    let $this = $(this);
    let copiedValue = $this.data('value');
    navigator.clipboard.writeText(copiedValue).then(() => {
        $this.addClass('copied');
        setTimeout(() => {
            $this.removeClass('copied');
        }, 500);
    }).catch((error) => {
        // Code to handle any errors that occurred while copying
        console.log('Unable to copy text: ', error);
    });
})
$(document).ready(function(){
    $('#submit_verification_code').on('click', function() {
        var code = $('#verification_code').val();
        if (code.length === 6) {
            $(this).closest('form').submit();
        } else {
            alert('Please enter a 6-digit verification code.');
        }
    });
});

